import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import { useEffect } from "react";

const Register = () => {
  const navigate = useNavigate();

  // Redirect naar login pagina na 5 seconden
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-1 flex flex-col md:flex-row">
        {/* Left side - Image */}
        <div className="relative flex-1 hidden md:block">
          <img 
            src="https://cdn.prod.website-files.com/652f959dc0b77fa8dd640d5b/652fbeaa0b9f03e07e889702_wrapper.jpg"
            alt="Car background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        {/* Right side - Disabled message */}
        <div className="flex-1 flex items-center bg-black bg-gradient-to-r from-[#B1A06D]/10 to-[#B1A06D]/5">
          {/* Logo */}
          <img 
            src="/lovable-uploads/f0397fdb-65b1-425f-a824-0229bd3e12d4.png"
            alt="Logo"
            className="absolute top-8 left-8 h-8"
          />
          
          <div className="w-full max-w-md mx-auto p-6">
            <div className="space-y-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <h1 className="text-3xl font-bold text-white tracking-wide mb-4">
                  REGISTRATIE UITGESCHAKELD
                </h1>
              </div>
              
              <div className="space-y-4 text-center">
                <p className="text-white/80 text-lg">
                  Het aanmaken van nieuwe accounts is momenteel niet mogelijk.
                </p>
                <p className="text-white/60">
                  Voor toegang tot uw Vermado account kunt u inloggen met uw bestaande gegevens.
                </p>
                <p className="text-white/50 text-sm">
                  U wordt automatisch doorgestuurd naar de inlogpagina in 5 seconden...
                </p>
              </div>
              
              <div className="space-y-3">
                <Button
                  onClick={() => navigate("/login")}
                  className="w-full bg-[#ea384c] hover:bg-[#ea384c]/90 text-white py-6"
                >
                  NAAR INLOGPAGINA
                </Button>
                
                <Button
                  onClick={() => navigate("/")}
                  variant="outline"
                  className="w-full border-white/30 text-white hover:bg-white/10 py-6"
                >
                  TERUG NAAR HOME
                </Button>
              </div>
              
              <div className="text-center mt-6">
                <p className="text-white/60 text-sm">
                  Vragen over toegang?{" "}
                  <a
                    href="/contact"
                    className="text-[#ea384c] hover:text-[#ea384c]/80 underline"
                  >
                    Neem contact op
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;